import angular from 'angular';

import CheckmarkComponent from './checkmark.cmpt';

export default angular
    .module('application.component.checkmark', [])
    .component(CheckmarkComponent.selector, CheckmarkComponent);



// WEBPACK FOOTER //
// ./src/application/component/checkmark/index.js